export default __webpack_public_path__ + "static/media/wordpress.4d5a2b3a.svg";